<script lang="ts">
	import { onDestroy } from 'svelte';

	import { INSTALL_PWA_REVEAL_DURATION_MS, installPwaRevealRequest } from './installPwa';

	let visible = false;
	let revealTimer: ReturnType<typeof setTimeout> | null = null;
	let handledRequest = 0;

	$: if ($installPwaRevealRequest > handledRequest) {
		handledRequest = $installPwaRevealRequest;
		visible = true;

		if (revealTimer) {
			clearTimeout(revealTimer);
		}

		revealTimer = setTimeout(() => {
			visible = false;
			revealTimer = null;
		}, INSTALL_PWA_REVEAL_DURATION_MS);
	}

	onDestroy(() => {
		if (revealTimer) {
			clearTimeout(revealTimer);
		}
	});
</script>

{#if visible}
	<div class="install-pwa-reveal" aria-hidden="true"></div>
{/if}

<style>
	.install-pwa-reveal {
		position: fixed;
		z-index: 1001;
		inset: 0;
		pointer-events: none;
		background: rgba(0, 0, 0, 0.001);
		-webkit-backdrop-filter: blur(100px);
		backdrop-filter: blur(100px);
		animation: install-pwa-reveal 900ms cubic-bezier(0.22, 1, 0.36, 1) both;
		will-change: backdrop-filter;
	}

	@keyframes install-pwa-reveal {
		from {
			-webkit-backdrop-filter: blur(100px);
			backdrop-filter: blur(100px);
		}
		to {
			-webkit-backdrop-filter: blur(0);
			backdrop-filter: blur(0);
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.install-pwa-reveal {
			animation: none;
			-webkit-backdrop-filter: none;
			backdrop-filter: none;
		}
	}
</style>
